export default __webpack_public_path__ + "static/media/cheese_distribution_icon.434f637a.png";